import type { BariPostDietConsultReportData } from '@common/validation/customControls/bariPost/bariPostDietConsultReport/v1/bariPostDietConsultReportSchemaV1';

export const initialData: BariPostDietConsultReportData = {
    assets: [],
    bijzonderheden: null,
    bijzonderheden_omschrijving: null,
    datum_consult: null,
    verslag_consult: null,
};
